// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const paginationClasses = {
  pageItem: "qui-pagination__page-item",
  pageMetadata: "qui-pagination__page-metadata",
  pageSize: "qui-pagination__page-size",
  pageSizeLabel: "qui-pagination__page-size-label",
  root: "qui-pagination__root",
} as const
